export enum formMode {
  signin = "signin",
  signup = "signup",
}
